import React from "react";
import "../css/Grid.css";
import { userButton } from './UserButton.js';

const Header = ({ user }) => {
  const userButtons = user.userButtonList
    .slice()
    .sort((a, b) => a.order - b.order)
    .map((item) =>
      userButton(user.userId, item.buttonId, item.url, item.text)
    );

  const handle = `@${user.username}`;

  return (
    <section className="profile-header">
      <div className="profile-details">
        <img
          src={user.profilePicUrl}
          alt="Profile"
          className="profile-avatar"
        />
        <div className="profile-username">{handle}</div>
      </div>

      <div className="profile-buttons-wrapper">
        <label className="profile-buttons-label">
          {user.profilePageDisclosure}
        </label>

        <div className="profile-buttons">
          {userButtons}
        </div>
      </div>
    </section>
  );
};

export default Header;